import { SwapSessao } from './swap-sessao.model';

/**
 * Envelope de resposta da consulta paginada (`PR_SWAP_SESSAO_CONSULTA`).
 * `itens` contém apenas a página corrente; `totalDeItens` é o total
 * geral aplicando os filtros (sem paginar) — útil para a tela calcular
 * o número de páginas.
 */
export interface SwapSessaoConsultaResultado {
  itens: SwapSessao[];
  totalDeItens: number;
}
